<template>
  <v-card elevation="0">
    <v-card-title>
      <span class="headline">{{ title }}</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-select
                :items="masters.processTypes"
                v-model="process.process_type"
                :loading="loading"
                label="Tipo de proceso *"
                item-value="id"
                item-text="name"
                :disabled="!processTypeAndMaterialEditable"
                @change="errors.process_type = []"
                @input="processTypeChanged"
                :error-messages="errors.process_type"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                :items="materials"
                v-model="process.material"
                :loading="loading"
                label="Materia Prima *"
                item-value="id"
                item-text="name"
                :disabled="!processTypeAndMaterialEditable || !process.process_type"
                @change="errors.material = []"
                :error-messages="errors.material"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                label="Turno"
                suffix="horas"
                type="number"
                v-model="process.worker_schedule_hours"
                @input="errors.worker_schedule_hours = []"
                :error-messages="errors.worker_schedule_hours"
                />
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                label="Descanso"
                suffix="minutos"
                type="number"
                v-model="process.break_time"
                @input="errors.break_time = []"
                :error-messages="errors.break_time"
                />
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="startDate"
                label="Fecha comienzo"
                @change="errors.start = []"
                :error-messages="errors.start"/>
            </v-flex>
            <v-flex xs12 sm6>
              <time-picker
                :time.sync="startTime"
                @change="errors.start = []"
                label="Hora comienzo"/>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="endDate"
                label="Fecha fin"
                @change="errors.end = []"
                :error-messages="errors.end"/>
            </v-flex>
            <v-flex xs12 sm6>
              <time-picker
                :time.sync="endTime"
                @change="errors.end = []"
                label="Hora fin"/>
            </v-flex>
            <v-flex xs12 sm6 v-if="process.id">
              <v-text-field
                label="Total paradas técnicas"
                suffix="minutos"
                type="number"
                disabled
                v-model="process.minutes_lost_on_incidents"
                />
            </v-flex>
            <v-flex xs12 sm6 v-if="process.id">
              <v-select
                :items="masters.statuses"
                v-model="process.status"
                :loading="loading"
                :cache-items="true"
                label="Estado"
                item-value="id"
                item-text="name"
                @change="fieldErrors.status = []"
                :error-messages="fieldErrors.status"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12>
               <v-select
                  :items="masters.tags"
                  v-model="process.tags"
                  :loading="loading"
                  item-value="id"
                  item-text="name"
                  label="Etiquetas *"
                  multiple
                  chips
                  @change="errors.tags = []"
                  :error-messages="errors.tags"
                  required
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  v-model="process.comments"
                  label="Comentarios"
                  @input="fieldErrors.comments = []"
                  :error-messages="fieldErrors.comments"></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*campos obligatorios</small>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn v-if="showCancel" flat color="accent" @click="$emit('cancel')">Cancelar</v-btn>
      <v-btn
        @click="$emit('submit')"
        :disabled="!valid"
        large
        depressed
        color="accent"
        >
          {{ actionName }}
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import api from '@/api/app'

import formMixin from '@/mixins/formMixin'

export default {
  name: 'processForm',
  props: ['isValid', 'showCancel', 'errors', 'process', 'title', 'actionName', 'masters'],
  mixins: [formMixin],
  data () {
    return {
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
      materials: []
    }
  },
  methods: {
    loadProcessTypeMaterials (processType) {
      return api.getProcessTypeRawMaterials(processType).then(response => {
        this.materials = response
      })
    },
    processTypeChanged () {
      this.process.material = null
      this.loading = true
      this.loadProcessTypeMaterials(this.process.process_type).then(() => {
        this.loading = false
      })
    },
    hasEmptyWeight (weighing) {
      return !weighing['weight'] || parseInt(weighing['weight']) === 0
    }
  },
  computed: {
    processTypeAndMaterialEditable () {
      if (!this.process.weighings) return true
      return this.process.weighings.every(this.hasEmptyWeight)
    }
  },
  watch: {
    valid () {
      this.$emit('update:isValid', this.valid)
    },
    process () {
      const startDateTime = this.$options.filters.splitDateTime(this.process.start)
      if (startDateTime) {
        this.startDate = startDateTime.date
        this.startTime = startDateTime.time
      }
      const endDateTime = this.$options.filters.splitDateTime(this.process.end)
      if (endDateTime) {
        this.endDate = endDateTime.date
        this.endTime = endDateTime.time
      }
    },
    startDate () {
      this.process.startDate = this.startDate
      this.$emit('update:process', this.process)
    },
    startTime () {
      this.process.startTime = this.startTime
      this.$emit('update:process', this.process)
    },
    endDate () {
      this.process.endDate = this.endDate
      this.$emit('update:process', this.process)
    },
    endTime () {
      this.process.endTime = this.endTime
      this.$emit('update:process', this.process)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/ProcessForm.vue